import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Shared shell for /recruitment/* (cloned from AdminLayout). */
export function RecruiterLayout({ children }: { children: React.ReactNode }): JSX.Element {
  const { t } = useTranslation();
  const tab = ({ isActive }: { isActive: boolean }): string => `admin-tab${isActive ? ' admin-tab--active' : ''}`;
  return (
    <div className="admin-shell">
      <nav className="admin-tabs" aria-label={t('recruitment.nav.sectionsLabel')}>
        <NavLink to="/recruitment/earnings" className={tab}>{t('recruitment.tabs.earnings')}</NavLink>
        <NavLink to="/recruitment/users" className={tab}>{t('recruitment.tabs.users')}</NavLink>
        <NavLink to="/recruitment/plans" className={tab}>{t('recruitment.tabs.plans')}</NavLink>
        <NavLink to="/recruitment/trials" className={tab}>{t('recruitment.tabs.trials')}</NavLink>
        <NavLink to="/recruitment/docs" className={tab}>{t('recruitment.tabs.docs')}</NavLink>
      </nav>
      {children}
    </div>
  );
}
